import { BaseModel } from "sjs-base-model";

export default class GenreModel extends BaseModel {
  public readonly name: string = "";
  public readonly slug: string = "";

  constructor(data: Partial<GenreModel>) {
    super();

    this.update(data);
  }
}
